let menuContent = {
    init() {

        var nb = $('.menu-content li a').length;
        if(nb == 0){
            $('.menu-content').hide(0);
        }

        $('.menu-content .action').click(function(){
            $(this).toggleClass('active');
            $('.menu-content ul').slideToggle(300);
        })

        $('.menu-content li a').click( function() {
            var page = $(this).attr('href');
            var speed = 750;
            $('html, body').animate( { scrollTop: $(page).offset().top }, speed );
            return false;
        });

    }
}

export default menuContent;
